import { List } from "immutable";
import { createSelector } from "reselect";

import { CourseId } from "../models/state/courses/course/Course";
import {
  getAllSectionContentIdsFromSections,
  getAllSectionExerciseContentIdsFromSections,
  getAllSections,
  getCourseSectionIds
} from "./state";
import * as sectionsSelectors from "./state/sections";

// Use makeGetAllCourseContentIds instead if possible
export function getAllCourseContentIds(
  state: any,
  courseId: string
): List<string> {
  const sectionIds = getCourseSectionIds(state, courseId);
  return getAllSectionContentIdsFromSections(state, sectionIds);
}

export function makeGetAllCourseContentIds(courseId: CourseId) {
  return createSelector(
    getAllSections,
    (state: any) => getCourseSectionIds(state, courseId),
    sectionsSelectors.getAllSectionContentIdsFromSections
  );
}

export function getAllCourseExerciseContentIds(
  state: any,
  courseId: string
): List<string> {
  const sectionIds = getCourseSectionIds(state, courseId);
  return getAllSectionExerciseContentIdsFromSections(state, sectionIds);
}
